var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticClass:"content-header",attrs:{"type":"flex","align":"center"}},[_c('h2',{staticClass:"content-header__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }